/**
 * store/reducers/trip/params.js 对象的辅助接口
 * doc: https://doc.oschina.net/xingchengzushou?t=244704
 */
// import moment from 'moment';


/**
 * 设置开始日期
 * @param {*} params tripParams
 * @param {*} timestamp 传入moment格式的的时间
 */
export function setStartDate(params, timestamp) {
  params = {...params};

  params.start_date = timestamp ? timestamp.format('YYYY-MM-DD') : '';

  return params;
}


/**
 * 设置结束日期
 * @param {*} params tripParams
 * @param {*} timestamp 传入moment格式的的时间
 */
export function setEndDate(params, timestamp) {
  params = {...params};

  params.end_date = timestamp ? timestamp.format('YYYY-MM-DD') : '';

  return params;
}

// 设置城市列表
export function setCityList(params, value) {
  params = {...params};

  params.city_day_list = value;

  return params;
}

// 添加城市
export function addCity(params, city) {
  params = {...params};

  params.city_day_list = [...params.city_day_list, city];

  return params;
}

// 移除城市，只能通过索引移除（因为会重复）
export function removeCity(params, index) {
  params = {...params};
  if(params.city_day_list && params.city_day_list.length){
    params.city_day_list = params.city_day_list.filter(function (city, i) {
      return i !== index;
    });
  }


  return params;
}

// 排序城市
export function sortCityList(params) {
  return params;
}

// 增加天数
export function increaseCityDay(params, index) {
  let day = params.city_day_list[index].day;

  day += 1;
  params = setCityDay(params, index, day);

  return params;
}

// 减少天数
export function reduceCityDay(params, index) {
  let day = params.city_day_list[index].day;
  if(day === 0){
    return params;
  }

  day -= 1;
  if (day < 0) {
    day = 0;
  }

  params = setCityDay(params, index, day);

  return params;
}

export function setCityDay(params, index, value) {
  params = {...params};
  params.city_day_list = [...params.city_day_list];
  params.city_day_list[index] = {
    ...params.city_day_list[index],
    day: value
  };

  return params;
}



// WEBPACK FOOTER //
// ./src/helpers/tripParams.js